
/* WELCOME MESSAGE */ const $58f8fcd8f54fc427$var$welcomeMessage = "Bienvenue sur origenial.fr !\nQue venez-vous faire dans les logs ?\nQue ce soit pour un bug, par curiosit\xe9, ou pour obtenir r\xe9ponse \xe0 vos questions, n'h\xe9sitez pas \xe0 nous contacter par mail.";
/* INIT SCRIPT */ window.onload = ()=>{
    console.log($58f8fcd8f54fc427$var$welcomeMessage);
};
/**
 * Details/summary HTML element
 * Only open one element at a time
 */ if (document.querySelector("details")) {
    // Fetch all the details elements
    const details = document.querySelectorAll("details");
    // Add onclick listeners
    details.forEach((targetDetail)=>{
        targetDetail.addEventListener("click", ()=>{
            // Close all details that are not targetDetail
            details.forEach((detail)=>{
                if (detail !== targetDetail) detail.removeAttribute("open");
            });
        });
    });
}


//# sourceMappingURL=index.01d6730e.js.map
